module.exports = __webpack_public_path__ + "media/country_flags/mh-2f1dd65a.png";